module.exports = __webpack_public_path__ + "img/55.142d1780.jpg";